<template>
    <div>
        <v-cookie></v-cookie>
        <div class="place">
            <span>位置：</span>
            <ul class="placeul">
                <li><a href="#">首页</a></li>
                <li><a href="#">账户设置</a></li>
                <li><a href="invoiceapply">发票申请</a></li>
            </ul>
        </div>
        <div class="formbody">
            <div class="formtitle"><span>发票申请</span></div>
            <ol>
                <el-tag type="danger" style="letter-spacing: 2px;margin-right: 15px;">2年内共{{list.length}}个订单可开票，已选{{chooseNum}}个</el-tag>
                <el-tag type="info" style="letter-spacing: 2px;margin-right: 15px;">
                    <label style="color:black;">可开票金额￥</label>
                    <label style="color:red;">{{total_money}}</label>
                    <label style="color:black;"> 元，已选金额￥</label>
                    <label style="color:red;">{{choose_money}}</label>
                    <label style="color:black;"> 元</label>
                </el-tag>
                <el-tooltip class="item" effect="dark" content="100以下的只能开电子发票或选择多项开票金额累加大于100" placement="top-start">
                    <el-button type="primary" plain class="top_button" @click="showchoosekaipiao()" style="letter-spacing: 2px;" :disabled="idList.length == 0 ? true : false">选中项开票</el-button>
                </el-tooltip>
            </ol>
            <div id="usual1" class="usual">
                <div id="tab1" class="tabson">
                    <table class="tablelist">
                        <thead>
                            <tr>								
                                <th style="width:3%;"><input type="checkbox" name="all" id="all" @click="selectall()"/></th>
                                <th style="width:10%;">订单编号</th>
                                <th style="width:40%;">订单内容</th>
                                <th style="width:14%;">订单完成时间</th>
                                <th style="width:10%;">可开票金额</th>
                                <th style="width:10%;">状态</th>
                                <th style="width:6%;">操作</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in list">
                                <td style="width:3%;">
                                    <input type="checkbox" name="ids" id="ids" class="pr5" :value="item.id" :data-money="item.money" @click="choosenumoperation(item.id, item.money)"/>
                                </td>
                                <td style="width:10%;">
                                    {{item.xpaynumber}}
                                </td>
                                <td style="width:40%;">
                                    {{item.subject}}
                                </td>
                                <td style="width:14%;">
                                    {{item.createtime.split('.')[0]}}
                                </td>
                                <td style="width:10%;">
                                    {{item.money}}
                                </td>
                                <td style="width:10%;">
                                    <template v-if="item.billingState == 0">
                                        可开票
                                    </template>
                                    <template v-else-if="item.billingState == 1">
                                        已开票
                                    </template>
                                    <template v-else-if="item.billingState == 2">
                                        已作废
                                    </template>
                                    <template v-else-if="item.billingState == 3">
                                        开票中
                                    </template>
                                    <template v-else-if="item.billingState == 4">
                                        不可开票
                                    </template>
                                </td>
                                <td style="width:6%;">
                                    <!-- <el-tooltip class="item" effect="dark" content="开票最低金额为100,低于100请选择多项同时开票" placement="top-start">
                                        <el-button type="text" @click="showkaipiao(item.id, item.money)" :disabled="item.money >= 100 ? false: true">开票</el-button>
                                    </el-tooltip> -->
                                    <el-tooltip class="item" effect="dark" content="100以下的只能开电子发票或选择多项开票金额累加大于100" placement="top-start">
                                        <el-button type="text" @click="showkaipiao(item.id, item.money)">开票</el-button>
                                    </el-tooltip>
                                </td>
                            </tr>     
                        </tbody>
                    </table>
                    <div class="pagin">
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="pageIndex"
                            :page-sizes="[pageSize]"
                            :page-size="50"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="totalCount">
                        </el-pagination>
                    </div>

                    <!-- 查询等待 -->
                    <div style="position: fixed; width:100%; height:100%; z-index:9999; background:rgb(51, 51, 51); opacity: 0.3; 
                        top: 0; left: 0;display: block;" v-show="loadingShow"></div>
                    <div style="position:fixed; left: 50%; top:50%; transform: translate3d(-50%, -50%, 0px); -ms-transform: translate3d(-50%, -50%, 0px);
                        -webkit-transform: translate3d(-50%, -50%, 0px); z-index: 10000;" v-show="loadingShow">
                        <i class="el-icon-loading" style="font-size: 40px;color:coral;"></i>
                        <div style="margin-left:-20px;color:coral;"><span style="font-size: 13px;">查询中,请稍后...</span></div>
                    </div>

                    <ul class="infolist" style="margin-top:10px;">
                        <li><b style="font-size: 15px;margin-left:-40px;">注意：</b></li>
                        <li><b style="color:red;">关于发票</b></li>
                        <li><span style="margin-left: 20px;font-size:12px;letter-spacing: 0.5px;">（1）最小开票金额为100起开,1000以上包邮,1000以下请联系客服</span></li>
                        <li><span style="margin-left: 20px;font-size:12px;letter-spacing: 0.5px;">（2）请仔细核对发票抬头、金额、税号、地址及其他相关信息，因为信息填写错误导致的发票开具、邮寄出错，将不能重开</span></li>
                        <li><span style="margin-left: 20px;font-size:12px;letter-spacing: 0.5px;">（3）发票开具后，除发生开票有误、发票抵扣联、发票联均无法认证等情形外，不予退换</span></li>
                        <li><span style="margin-left: 20px;font-size:12px;letter-spacing: 0.5px;">（4）只能开具<b><label style="color:red;">两年内</label></b>有效发票</span></li>
                        <li><span style="margin-left: 20px;font-size:12px;letter-spacing: 0.5px;">（5）开票时间，从申请日开始，<b><label style="color:red;">3~5个工作日</label></b></span></li>
                        <li><b style="color:red;">开票提示</b></li>
                        <li><span style="margin-left: 20px;font-size:12px;letter-spacing: 0.5px;">（1）由于税控机的限制，发票抬头如为英文，请不要超过30个字母包含空格。</span></li>
                        <li><span style="margin-left: 20px;font-size:12px;letter-spacing: 0.5px;">（2）普通客户一天只能申请一张发票，发票会在申请的第三天邮寄出；如果您没有提出开具发票的申请，我们默认您暂时不需要发票。</span></li>
                        <li><span style="margin-left: 20px;font-size:12px;letter-spacing: 0.5px;">（3）如果由于发票中填写的付款单位(个人)名称与实际不符而出现的问题，引起的相关法律责任由提交开发票信息的公司(个人)全部承担；与杭州快鱼科技有限公司无关。</span></li>
                        <li><span style="margin-left: 20px;font-size:12px;letter-spacing: 0.5px;">（4）发票查询时间：请在发票寄出2个月内查询，邮寄时间超过2个月的发票将不负责为您查询。（因快递公司行业标准查询时间为2个月）</span></li>
                    </ul>

                    <!-- 添加新地址 -->
                    <div v-show="showInvoice" style="position: fixed; width:100%; height:100%; z-index:199; background:rgb(51, 51, 51); opacity: 0.6; 
                        top: 0; left: 0;display: block;"/>
                    <div class="tip" style="z-index:200;display: block;width:800px;min-height:auto;max-height: 450px; " v-show="showInvoice">
                        <div class="tiptop"><span>发票申请</span><a @click="close();"></a></div>
                        <ul class="forminfo" style="margin-top:10px;">
                            <li>
                                <label>开票金额<b>*</b></label>
                                <el-tag type="danger" style="background: white;">{{openInvoice.money}} 元</el-tag>
                                <el-tooltip class="item" effect="dark" content="没有默认发票信息？请前往设置,已设置用户直接点击使用或手动输入" placement="top-start">
                                    <el-button type="primary" style="margin-left:20px;letter-spacing: 1px;" @click="useinvoiceinformation()">使用默认发票信息</el-button>
                                </el-tooltip>
                                <el-tooltip class="item" effect="dark" content="没有默认地址？请前往设置,已设置用户直接点击使用或手动输入" placement="bottom-end">
                                    <el-button type="primary" style="margin-left:20px;letter-spacing: 1px;" @click="useinvoiceaddress()">使用默认地址</el-button>
                                </el-tooltip>
                            </li>
                            <li>
                                <label>发票抬头<b>*</b></label>
                                <el-input placeholder="请填写营业执照上的全称" v-model="openInvoice.lookedup" style="width:260px;"></el-input>
                            </li>
                            <li>
                                <label>开票类型<b>*</b></label>
                                <template v-if="openInvoice.money < 100">
                                    <el-radio v-model="openInvoice.invoicetype" label="电子发票" border style="width:110px;">
                                        <label style="margin: -43px 0px 0px 10px;font-size: 14px;cursor: pointer;" @click="checkinvoicetype(0)">电子发票</label>
                                    </el-radio>
                                </template>
                                <template v-else>
                                    <el-radio v-model="openInvoice.invoicetype" label="电子发票" border style="width:110px;">
                                        <label style="margin: -43px 0px 0px 10px;font-size: 14px;cursor: pointer;" @click="checkinvoicetype(0)">电子发票</label>
                                    </el-radio>
                                    <!-- <el-radio v-model="openInvoice.invoicetype" label="普通发票" border style="width:110px;margin-left:10px;">
                                        <label style="margin: -43px 0px 0px 10px;font-size: 14px;cursor: pointer;" @click="checkinvoicetype(1)">普通发票</label>
                                    </el-radio> -->
                                    <el-radio v-model="openInvoice.invoicetype" label="增值税专用发票" border style="width:140px;margin-left:10px;">
                                        <label style="margin: -43px 0px 0px 10px;font-size: 14px;cursor: pointer;" @click="checkinvoicetype(2)">增值税专用发票</label>
                                    </el-radio>
                                </template>
                                <ol style="color:crimson; line-height: 40px;font-size: 14px;">(普票、专票都是电子发票)</ol>
                            </li>
                            <li>
                                <label>发票内容<b>*</b></label>
                                <el-radio v-model="openInvoice.invoicecontent" label="电信增值服务" border style="width:130px;">
                                    <label style="margin: -43px 0px 0px 10px;font-size: 14px;cursor: pointer;">{{openInvoice.invoicecontent}}</label>
                                </el-radio>
                            </li>
                            <li>
                                <label>纳税人识别号<b>*</b></label>
                                <el-input placeholder="请填写15到20位有效纳税人识别号" v-model="openInvoice.taxpayerId" style="width:360px;"></el-input>
                            </li>
                            <template>
                                <li>
                                    <label>邮箱地址<b>*</b></label>
                                    <el-input placeholder="请输入邮箱地址" v-model="openInvoice.email" style="width:360px;"></el-input>
                                </li>
                            </template>
                            <template v-if="openInvoice.invoicetype == '增值税专用发票'">
                                <li>
                                    <label>银行卡号<b>*</b></label>
                                    <el-input placeholder="请填写您开户许可证上的银行账号" v-model="openInvoice.cardId" style="width:360px;"></el-input>
                                </li>
                                <li>
                                    <label>开户行<b>*</b></label>
                                    <el-input placeholder="请填写您开户许可证上的开户银行" v-model="openInvoice.bank" style="width:360px;"></el-input>
                                </li>
                                <li>
                                    <label>注册地址<b>*</b></label>
                                    <el-input placeholder="请填写营业执照上的注册地址" v-model="openInvoice.corpAddr" style="width:360px;"></el-input>
                                </li>
                                <li>
                                    <label>注册企业电话<b>*</b></label>
                                    <el-input placeholder="请填写您公司有效的联系电话" v-model="openInvoice.corpTel" style="width:360px;"></el-input>
                                </li>
                            </template>
                            <!-- <template v-if="openInvoice.invoicetype == '普通发票' || openInvoice.invoicetype == '增值税专用发票'">
                                <li>
                                    <label>收件人<b>*</b></label>
                                    <el-input placeholder="请输入收件人" v-model="openInvoice.recipient" style="width:360px;"></el-input>
                                </li>
                                <li>
                                    <label>收货地址<b>*</b></label>
                                    <el-input placeholder="请输入收货地址" v-model="openInvoice.address" style="width:360px;"></el-input>
                                </li>
                                <li>
                                    <label>手机号<b>*</b></label>
                                    <el-input placeholder="请输入手机号" v-model="openInvoice.mobile" style="width:360px;"></el-input>
                                </li>
                                <li>
                                    <label>邮编<b>*</b></label>
                                    <el-input placeholder="请输入邮编" v-model="openInvoice.code" style="width:360px;"></el-input>
                                </li>
                                <li>
                                    <label>邮寄方式<b>*</b></label>
                                    <el-radio v-model="openInvoice.post" label="顺丰到付" border style="width:110px;">
                                        <label style="margin: -43px 0px 0px 10px;font-size: 14px;cursor: pointer;" @click="changepost(0)">顺丰到付</label>
                                    </el-radio>
                                </li>
                                <li>
                                    <label>固定电话<b>*</b></label>
                                    <el-input placeholder="请输入固定电话" v-model="openInvoice.phone" style="width:360px;"></el-input>
                                </li>
                            </template> -->
                            <li>
                                <label>备注</label>
                                <el-input placeholder="备注可选填" v-model="openInvoice.discription" type="textarea" style="width:360px;"></el-input>
                            </li>
                        </ul>
                        <div class="tipbtn">
                            <template v-if="openInvoice.invoicetype == '电子发票'">
                                <el-button type="primary" style="margin-left:-15px;" :disabled="openInvoice.email.trim().length == 0 || openInvoice.taxpayerId.trim().length == 0 || openInvoice.lookedup.trim().length == 0 ? true : false" @click="save()">提交申请</el-button>
                            </template>
                            <template v-else-if="openInvoice.invoicetype == '普通发票'">
                                <el-button type="primary" style="margin-left:-15px;" :disabled="openInvoice.recipient.trim().length == 0 || openInvoice.taxpayerId.trim().length == 0 || openInvoice.lookedup.trim().length == 0 || openInvoice.address.trim().length == 0 || openInvoice.code.trim().length == 0 || openInvoice.phone.trim().length == 0 || openInvoice.mobile.trim().length == 0 ? true : false" @click="save()">提交申请</el-button>
                            </template>
                            <template v-else-if="openInvoice.invoicetype == '增值税专用发票'">
                                <el-button type="primary" style="margin-left:-15px;" :disabled="openInvoice.recipient.trim().length == 0 || openInvoice.taxpayerId.trim().length == 0 || openInvoice.lookedup.trim().length == 0 || openInvoice.address.trim().length == 0 || openInvoice.code.trim().length == 0 || openInvoice.phone.trim().length == 0 || openInvoice.mobile.trim().length == 0 || openInvoice.cardId.trim().length == 0 || openInvoice.bank.trim().length == 0 || openInvoice.corpAddr.trim().length == 0 || openInvoice.corpTel.trim().length == 0 ? true : false" @click="save()">提交申请</el-button>
                            </template>
                        </div> 
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import cookie from '@/components/cookie.vue'
import '@/assets/js/jquery.js'
export default {
    data() {
        return{
            list: [],
            pageIndex: 0,
            pageSize: 50,
            totalCount: 0,
            chooseNum: 0,
            total_money: 0.0,
            choose_money: 0.0,
            idList: [],
            showInvoice: false,
            openInvoice: {
                money: 0,
                invoicetype: '电子发票',
                //电子发票参数
                email: '',
                discription: '',
                //三种发票公共参数
                invoicecontent: '电信增值服务',
                lookedup: '',
                taxpayerId: '',
                //普通发票--增值税专用发票公共参数
                recipient: '',
                code: '',
                address: '',
                post: '顺丰到付', //邮寄方式
                phone: '',
                mobile: '',
                //增值税专用发票参数
                bank: '',
                cardId: '',
                corpAddr: '',
                corpTel: '',
                ids: '',
            },
            loadingShow: true,
        }
    },
    components : {
        'v-cookie' : cookie,
    },
    mounted() {
        this.pageChange(1)
    },
    methods: {
        handleSizeChange(val) {
            this.pageChange(val)
        },
        handleCurrentChange(val) {
            this.pageChange(val)
        },
        pageChange(pageIndex) {
            this.loadingShow = true;
            this.choose_money = 0;
            this.total_money = 0;
            var that = this
            let param = {'pageIndex': pageIndex, 'pageSize': this.pageSize}
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + "/invoice/getvalidinvoicemoney.json",
                data: param,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                if(res.data.code == '0000000')
                {
                    that.list = res.data.validinvoicemoneyList;
                    that.total_money = res.data.totalmoney.toFixed(3);
                    that.pageIndex = res.data.page.pageIndex;
                    that.pageSize = res.data.page.pageSize;
                    that.totalCount = res.data.page.totalCount;
                    document.getElementById('all').checked = false;
                    that.selectall();
                    that.loadingShow = false;
                }
                else
                {
                    that.$alert(res.data.msg)
                }
            })
        },
        selectall() {
            this.choose_money = 0;
            this.choosecheckboxvalue();
            var checkers = document.getElementsByName('ids');
            if (document.getElementById("all").checked == true)
            {
                for ( var i = 0; i < checkers.length; i++)
                {
                    checkers[i].checked = true;
                    this.chooseNum = this.list.length;
                    // document.getElementById('all').checked = true;
                    if(!this.idList.includes(checkers[i].value * 1)){
                        this.idList.push(checkers[i].value * 1);
                    }
                    // this.idList.push(checkers[i].value * 1)
                }
            }
            else
            {
                // this.idList.map((item,index)=>{
                //     if(item == id){
                //         this.idList.splice(index,1)
                //     }
                // })
                for ( var i = 0; i < checkers.length; i++)
                {
                    checkers[i].checked = false;
                    this.chooseNum = 0;
                    this.choose_money = 0;
                    if(checkers[i].checked == false){
                        this.idList.map((item,index)=>{
                            if(item == checkers[i].value * 1){
                                this.idList.splice(index,1)
                            }
                        })
                    }
                }
            }
            // console.log(this.idList)
        },
        choosecheckboxvalue() {
            var ids = document.getElementsByName("ids");
            for(var i=0; i<ids.length; i++)
            {
                this.choose_money = ((this.choose_money)*1000 + (ids[i].getAttribute("data-money")*1000))/1000;
            }
        },
        choosenumoperation(id, money) {
            var ids = document.getElementsByName("ids");
            var said = "";
            for(var i=0; i<ids.length; i++)
            {
                // console.log(ids)
                if(ids[i].value == id &&　ids[i].checked == true )
                {
                    this.choose_money = ((this.choose_money)*1000+(money*1000))/1000;
                    this.chooseNum = this.chooseNum+1;
                    this.idList.push(id);
       
                }
                else if(ids[i].value == id &&　ids[i].checked == false)
                {
                    this.chooseNum = this.chooseNum-1;
                    this.choose_money =((this.choose_money)*1000-(money*1000))/1000;
                    this.idList.map((item,index)=>{
                        if(item == id){
                            this.idList.splice(index,1)
                        }
                    })
                }
                if(this.chooseNum == 0 || this.chooseNum  != ids.length)
                {
                    document.getElementById('all').checked = false;
                }
                else
                {
                    document.getElementById('all').checked = true;
                }
            }
            // console.log(this.idList)
            this.choose_money = this.choose_money.toFixed(3);
        },
        //显示开票操作
        showkaipiao(id, money) {
            if(money <=0 ){
                alert("开票金额不能小于0！");
                return;
            }
            this.openInvoice.money = money;
            this.idList = [];
            this.idList.push(id);
            this.openInvoice.ids = this.idList;
            this.showInvoice = true;
        },
        //显示选中项开票
        showchoosekaipiao() {
            if(this.choose_money < 100){
                alert("开票金额不能小于100！");
                return;
            }
            this.openInvoice.money = this.choose_money;
            this.openInvoice.ids = this.idList;
            this.showInvoice = true;
        },
        checkinvoicetype(invoicetype) {
            if(invoicetype == 0)
            {
                this.openInvoice.invoicetype = "电子发票";
            }
            else if(invoicetype == 1)
            {
                this.openInvoice.invoicetype = "普通发票";
            }
            else if(invoicetype == 2)
            {
                this.openInvoice.invoicetype = "增值税专用发票";
            }
        },
        changepost(type) {
            if(type == 0)
            {
                this.openInvoice.post = "顺丰到付";
            }
            else if(type == 1)
            {
                this.openInvoice.post = "快递邮寄";
            }
        },
        close() {
            this.openInvoice.lookedup = '';
            this.openInvoice.taxpayerId = '';
            this.openInvoice.cardId = '';
            this.openInvoice.bank = '';
            this.openInvoice.corpAddr = '';
            this.openInvoice.corpTel = '';
            this.openInvoice.recipient = '';
            this.openInvoice.address = '';
            this.openInvoice.mobile = '';
            this.openInvoice.code = '';
            this.openInvoice.phone = '';
            this.openInvoice.discription = '';
            this.openInvoice.invoicetype = '电子发票';
            this.openInvoice.invoicecontent = '电信增值服务';
            this.openInvoice.money = '0';
            this.openInvoice.ids = '';
            this.openInvoice.email = '';
            document.getElementById('all').checked = false;
            this.selectall();
            this.choose_money = 0;
            this.idList = [];
            this.showInvoice = false;
        },
        //提交发票申请
        save() {
            if(this.openInvoice.invoicetype == '普通发票' || this.openInvoice.invoicetype == '增值税专用发票')
            {
                if(this.openInvoice.mobile.trim().length != 11)
                {
                    this.$alert("请输入11位有效手机号");
                    return false;
                }
                if(this.openInvoice.phone.trim().length < 10)
                {
                    this.$alert("固定电话不正确,请填写区号")
                    return false;
                }
            }
            var that = this;
            let param = {'money': this.openInvoice.money, 'lookedup': this.openInvoice.lookedup, 'invoicetype': this.openInvoice.invoicetype, 'email': this.openInvoice.email,
                'invoicecontent': this.openInvoice.invoicecontent, 'taxpayerId': this.openInvoice.taxpayerId, 'cardId': this.openInvoice.cardId,
                'bank': this.openInvoice.bank, 'corpAddr': this.openInvoice.corpAddr, 'corpTel': this.openInvoice.corpTel, 'recipient': this.openInvoice.recipient,
                'address': this.openInvoice.address, 'mobile': this.openInvoice.mobile, 'code': this.openInvoice.code, 'post': this.openInvoice.post, 
                'phone': this.openInvoice.phone, 'discription': this.openInvoice.discription == null ? "" : this.openInvoice.discription, 'ids': this.openInvoice.ids}
            // alert(JSON.stringify(param))
            this.$confirm("发票信息填写无误并提交？", '确认发票信息', {
                confirmButtonText: '确定', 
                cancelButtonText: '取消',
                type: 'warning'
            }).then( () => {
                this.$ajax({
                    method: 'post',
                    url: this.GLOBAL.serverSrc + '/invoice/openinvoice.json',
                    data: param,
                    headers: {
                        'Content-Type': 'application/json;charset=UTF-8',
                        'token': this.GLOBAL.token,
                    }
                }).then(function(res) {
                    if('0000000' == res.data.code)
                    {
                        that.$message({
                            type: 'success',
                            message: "开票成功,可前往开票记录查询开票进度,有问题请联系客服",
                        });
                        that.close();
                        that.pageChange(1);
                    }
                    else
                    {
                        that.$alert(res.data.msg)
                    }
                })
            }).catch( () => {
                that.$message({
                    duration: 2000,
                    showClose: true,
                    type: 'error',
                    message: '已取消,请确认后提交'
                });
            });
        },
        //使用默认发票信息
        useinvoiceinformation() {
            var that = this;
            let data = {};
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + "/invoice/getstatusinvoiceinformation.json",
                data:data,
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                    'token': this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    that.openInvoice.lookedup = res.data.invoiceinformation.lookedup;
                    that.openInvoice.taxpayerId = res.data.invoiceinformation.taxpayerId;
                    that.openInvoice.cardId = res.data.invoiceinformation.cardId;
                    that.openInvoice.bank = res.data.invoiceinformation.bank;
                    that.openInvoice.corpAddr = res.data.invoiceinformation.corpAddr;
                    that.openInvoice.corpTel = res.data.invoiceinformation.corpTel;
                    that.$message({
                        type: 'success',
                        message: "使用默认发票信息成功,可手动修改"
                    });
                }
                else if('0010001' == res.data.code)
                {
                    that.$alert(res.data.msg)
                    return false;
                }
                else
                {
                    that.$confirm("没有设置默认发票信息,是否前往设置?", '提示', {
                        confirmButtonText: '确定', 
                        cancelButtonText: '不设置,手动输入',
                        type: 'warning'
                    }).then( () => {
                        that.$router.push("/invoiceinformationmanage")
                    }).catch( () => {
                        that.$message({
                            duration: 2000,
                            showClose: true,
                            type: 'error',
                            message: '已取消,手动输入或前往设置'
                        });
                    });
                }
            })
        },
        //使用默认地址
        useinvoiceaddress() {
            var that = this;
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + "/invoice/getstatusinvoiceaddress.json",
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                    'token': this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    that.openInvoice.recipient = res.data.invoiceaddress.recipient;
                    that.openInvoice.mobile = res.data.invoiceaddress.mobile;
                    that.openInvoice.address = res.data.invoiceaddress.address;
                    that.openInvoice.code = res.data.invoiceaddress.code;
                    that.openInvoice.email = res.data.invoiceaddress.email;
                    that.$message({
                        type: 'success',
                        message: "使用默认邮寄地址成功,可手动修改"
                    });
                }
                else if('0010001' == res.data.code)
                {
                    that.$alert(res.data.msg)
                    return false;
                }
                else
                {
                    that.$confirm("没有设置默认邮寄地址,是否前往设置?", '提示', {
                        confirmButtonText: '确定', 
                        cancelButtonText: '不设置,手动输入',
                        type: 'warning'
                    }).then( () => {
                        that.$router.push("/invoiceaddressmanage")
                    }).catch( () => {
                        that.$message({
                            duration: 2000,
                            showClose: true,
                            type: 'error',
                            message: '已取消,手动输入或前往设置'
                        });
                    });
                }
            })
        },
    }
}
</script>>

<style>
.el-radio__input{top:-10px;}
</style>


// WEBPACK FOOTER //
// src/components/invoice/invoiceapply.vue